import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';

export const isValidId = (id) => {
  if (Array.isArray(id)) return false;

  const int = fromAnyToNumber(id);
  return Number.isSafeInteger(int) && int > 0;
};

export const isNotValidId = (id) => {
  if (Array.isArray(id)) return true;

  const int = fromAnyToNumber(id);
  return !Number.isSafeInteger(int) || int <= 0;
};
